module.exports = __webpack_public_path__ + "static/media/dropbox.88a54c5a.svg";